<template>
  <v-layout class="footer-wrapper" cols wrap>
    <div class="footer-top-wrapper" v-if="!isQuebecFrench()">
      <h2>{{ $t('You might be interested in') }}</h2>
      <v-layout class="research-cards-wrapper" xs12>
        <v-card
          v-for="(item, index) in researchList"
          :key="index"
          class="flex research-card xs12 md4"
        >
          <div class="research-card--img">
            <img alt="logo" class="app-logo-desktop"
                 :src=item.image
            />
          </div>
          <div class="research-card--date">{{ item.date }}</div>
          <div class="research-card--title"><a :href=item.link>{{ item.title }}</a></div>
        </v-card>
      </v-layout>
      <v-layout class="research-cards--read-more" justify-center><a class="v-btn v-btn--flat v-btn--round theme--light" href="https://fraserinstitute.org">{{ $t('Read more') }}</a></v-layout>
    </div>

    <v-layout class="footer-bottom-wrapper" cols wrap justify-center align-end>
      <v-flex class="d-flex" xs12 md6>
        <v-flex class="footer-menu" xs12 sm6 md12>
          <ul class="d-md-inline-flex">
            <li v-for="(footerMenu, key) in footerMenus" :key="key"><a :href="footerMenu.path" :target="footerMenu.target">{{ footerMenu.title }}</a>
            </li>
          </ul>
        </v-flex>

        <v-flex class="footer-social-networks hidden-md-and-up" xs12 sm6>
          <a href="https://www.facebook.com/FraserInstitute" title="Facebook" target="_blank">
            <v-icon light>mdi-facebook</v-icon>
          </a>
          <a href="https://twitter.com/fraserinstitute" title="Twitter" target="_blank">
            <v-icon light>mdi-twitter</v-icon>
          </a>
          <a href="https://www.linkedin.com/company/the-fraser-institute" title="Linkedin" target="_blank">
            <v-icon light>mdi-linkedin</v-icon>
          </a>
          <a href="https://www.instagram.com/fraser_institute/" title="Instagram" target="_blank">
            <v-icon light>mdi-instagram</v-icon>
          </a>
          <a href="https://www.youtube.com/user/FraserInstitute" title="Youtube" target="_blank">
            <v-icon light>mdi-youtube</v-icon>
          </a>
        </v-flex>

      </v-flex>

      <v-layout class="footer-text" xs10 md5 justify-end flex>
        {{ footerText }}
      </v-layout>
      <v-flex xs2 md1 class="footer-logo">
        <a v-show="!isFrench" target="_blank" href="https://www.fraserinstitute.org/">
          <img alt="logo" class="app-logo-desktop"
               src="@/assets/images/logo-footer.png"
          />
        </a>
        <a v-show="isFrench" target="_blank" href="https://www.fraserinstitute.org/">
          <img alt="logo" class="app-logo-desktop"
               src="@/assets/images/logo-footer-fr.png"
          />
        </a>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  import RepositoryFactory from '@/services/RepositoryFactory';
  const menusService = RepositoryFactory.get('menus');
  const researchService = RepositoryFactory.get('researches');

  export default {
    name: "app-footer",
    data() {
      return {}
    },
    mounted() {
    },
    computed: {
      isFrench() {
        return this.$store.state.currentLanguage === 'fr';
      },
      footerMenus() {
        return menusService.getFooterMenu(this.$i18n.locale);
      },
      footerText() {
        return menusService.getFooterText(this.$i18n.locale);
      },
    },
    asyncComputed: {
      async researchList() {
        return await researchService.getResearchesByProvince();
      },
    },
    methods: {
      isQuebecFrench() {
        return (this.$i18n.locale === 'fr' && this.$store.state.currentMapProvince === 'Québec');
      }
    }
  }
</script>
